import React from 'react';
import { FunctionField, useLocale } from 'react-admin';

import { formatCurrency } from '../../locale';

export const CurrencyField = ({ source, allowZero = false, ...props }) => {
  const locale = useLocale();
  return <FunctionField source={source} render={record => formatCurrency(record?.[source], locale, allowZero)} {...props} />;
}
